var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Authenticator } from 'packages/authentication/services/Authenticator';
import { container, injectable } from 'tsyringe';
var GROUP_NAME_COMPANY_ADMIN = 'company_admin';
var GROUP_NAME_RECRUITMENT_MANAGER = 'recruitment_manager';
var GROUP_NAME_CONTENT_MANAGER = 'content_manager';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var OBJECT_NAME_JOB = 'job';
var OBJECT_NAME_TALENT = 'talent';
var OBJECT_NAME_EB_PAGE = 'eb_page';
var OBJECT_NAME_EB_ENTRY = 'eb_entry';
var Permissions = /** @class */ (function () {
    function Permissions() {
        this.auth = container.resolve(Authenticator);
    }
    Permissions.prototype.hasGroupAttached = function (group) {
        return !!this.auth.permissionData.groups && this.auth.permissionData.groups.includes(group);
    };
    Permissions.prototype.hasObjectAccess = function (object) {
        return !!this.auth.permissionData.objects && this.auth.permissionData.objects.includes(object);
    };
    Object.defineProperty(Permissions.prototype, "isAdmin", {
        get: function () {
            return this.auth.decodedToken ? this.auth.decodedToken.system_administrator : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "isJobillaUser", {
        get: function () {
            if (!this.auth.decodedToken) {
                return false;
            }
            return this.verifyJobillaEmail(this.auth.decodedToken.user.email);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "isCompanyAdmin", {
        get: function () {
            return this.hasGroupAttached(GROUP_NAME_COMPANY_ADMIN);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "isRecruitmentManager", {
        get: function () {
            return this.hasGroupAttached(GROUP_NAME_RECRUITMENT_MANAGER);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "canSwitchCompany", {
        get: function () {
            return this.isAdmin
                || this.auth.permissionData.companies.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "canAccessJobLists", {
        get: function () {
            return this.isAdmin
                || this.isCompanyAdmin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "canAccessInventory", {
        get: function () {
            return this.isAdmin
                || this.isCompanyAdmin;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "canAccessEb", {
        get: function () {
            if (this.isAdmin || this.isCompanyAdmin) {
                return true;
            }
            return this.hasGroupAttached(GROUP_NAME_CONTENT_MANAGER)
                || this.hasObjectAccess(OBJECT_NAME_EB_PAGE)
                || this.hasObjectAccess(OBJECT_NAME_EB_ENTRY);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "canAccessTrm", {
        get: function () {
            if (this.isAdmin || this.isCompanyAdmin || this.isRecruitmentManager) {
                return true;
            }
            return this.hasObjectAccess(OBJECT_NAME_TALENT);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Permissions.prototype, "canAccessSettings", {
        get: function () {
            return this.isAdmin || this.isCompanyAdmin;
        },
        enumerable: false,
        configurable: true
    });
    Permissions.prototype.verifyJobillaEmail = function (email) {
        var emailRegex = /^[^\s@]+@jobilla\.com$/;
        return emailRegex.test(email);
    };
    Permissions = __decorate([
        injectable()
    ], Permissions);
    return Permissions;
}());
export default Permissions;
